import React from 'react';
import thumbnailGenerator from '../../utils/ThumbnailGenerator';
import { InteractiveShape } from '../interactive/InteractiveShape';
import previewCommands from '../../utils/PreviewCommands';
import colorUtils from '../../utils/ColorUtils';
import zoomUtils from '../../utils/ZoomUtils';
import videoUtils from '../../utils/VideoUtils';
import storeManager from '../../../store/StoreManager';
import { hideMenus, setContextTarget } from '../../../actions/MenuActions';
import menuType from '../../../constants/MenuType';
import mouseUtils from '../../utils/MouseUtils';
import { selectShape } from '../../../actions/CurrentSlideActions';

export const Image = React.createClass({
    propTypes: {
        dispatch: React.PropTypes.func.isRequired,
        shapeModel: React.PropTypes.object.isRequired
    },
    checkSize() {
        if (previewCommands.isPlayMode() == true)
            return;

        setTimeout(this.checkImageSize, 5);
    },
    checkImageSize() {
        if (this.props.shapeModel.isNewImage == true)
            thumbnailGenerator.checkImageAspectRatio(this.props.shapeModel, this.props.dispatch);
    },
    isShapeSelected() {
        const state = storeManager.getState();
        const shapes = state.currentSlide.model.content;
        var i;

        for (i=0; i<shapes.length; i++)
            if (shapes[i].uuid == this.props.shapeModel.uuid) {
                if (shapes[i].isSelected == true)
                    return true;
                else
                    return false;
            }

        return false;
    },
    onKeyDown(e) {
        if (e.keyCode == 13) { // ENTER
            setTimeout(function() {
                this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
                this.props.dispatch(setContextTarget(this.props.shapeModel));

                setTimeout(function() {
                    var buttonMenu = document.getElementById('shapeMenuFirstElement');

                    if (buttonMenu)
                        buttonMenu.focus();
                }.bind(this), 20);
            }.bind(this), 20);
        }
    },
    onFocusHandler() {
        if (document.activeElement == this.refs.focusableElement) {
            if (!this.isShapeSelected())
                this.props.dispatch(selectShape(this.props.shapeModel.uuid));

            mouseUtils.activeElement = this.props.shapeModel.uuid;
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.shapeModel != newProps.shapeModel  || this.props.scaleProperties != newProps.scaleProperties || this.props.showCroppingMenu!=newProps.showCroppingMenu)
            return true;
        else
            return false;
    },
    render() {
        this.checkSize();

        const { shapeModel, dispatch } = this.props;

        var filterName;
        var filter;
        var filterUrl;

        if (shapeModel.backgroundVisible == false || shapeModel.fillOpacity == 0) {
            // the filter shouldn't be visible
        } else {
            filterName = 'f_' + shapeModel.uuid;
            filterUrl = 'url(#' + filterName + ')';

            filter = <filter id={filterName}>
                <feColorMatrix type='matrix' values={colorUtils.hexToMatrix(shapeModel.fill)}/>
            </filter>;
        }

        var clipPathObject;
        var realWidth = shapeModel.width;
        var realHeight = shapeModel.height;
        var newShapeModel = shapeModel;
        var x1 = 0;
        var y1 = 0;
        var clipId = 'hotSpot_' + shapeModel.uuid;
        var clipPath = 'url(#' + clipId + ')';
        var newX1 = 0;
        var newY1 = 0;

        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
            realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
            realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);

            x1 = realWidth * shapeModel.hotSpot.x1 / 100;
            y1 = realHeight * shapeModel.hotSpot.y1 / 100;
            var x2 = realWidth * shapeModel.hotSpot.x2 / 100;
            var y2 = realHeight * shapeModel.hotSpot.y2 / 100;

            newX1 = x1;
            newY1 = y1;

            if (shapeModel.isNewFlip){
                if (shapeModel.isCropAndFlipHorizontal)
                    newX1 = realWidth - x2;

                if (shapeModel.isCropAndFlipVertical)
                    newY1 = realHeight - y2;
            }

            if (zoomUtils.isCroppingMode()) {
                newShapeModel = Object.assign({}, shapeModel);
                newShapeModel.width = realWidth;
                newShapeModel.height = realHeight;
                newShapeModel.x = shapeModel.x - x1;
                newShapeModel.y = shapeModel.y - y1;

                x1=0;
                y1=0;

                newX1 = x1;
                newY1 = y1;
            } else {
                clipPathObject = <clipPath id={clipId}>
                    <rect x={newX1} y={newY1} width={x2 - x1} height={y2 - y1}></rect>
                </clipPath>
            }
        }

        var imageSrc = videoUtils.checkCacheBreaker(newShapeModel.xlinkHref);

        return (
            <InteractiveShape shapeModel={newShapeModel} dispatch={dispatch} rotatable={true} scaleProperties={this.props.scaleProperties}>
                <g transform={`translate(${newShapeModel.x} ${newShapeModel.y})`} opacity={newShapeModel.opacity}>
                    {filter}
                    <g filter={filterUrl}>
                        {clipPathObject}
                        <g transform={`translate(${-newX1} ${-newY1})`}>
                            <image
                                x={0}
                                y={0}
                                width={realWidth}
                                height={realHeight}
                                xlinkHref={imageSrc}
                                filter={newShapeModel.filter}
                                preserveAspectRatio='none'
                                clipPath={clipPath}
                            />
                        </g>
                        <rect x={0}
                              y={0}
                              width={newShapeModel.width}
                              height={newShapeModel.height}
                              fill='none'
                              stroke={newShapeModel.stroke}
                              strokeWidth={newShapeModel.strokeWidth}
                              strokeOpacity={newShapeModel.strokeOpacity}
                              preserveAspectRatio='none'/>
                        {
                            !shapeModel.isGrouped ?
                                <foreignObject>
                                    <a id={'interactiveElement_' + this.props.shapeModel.uuid} href='' ref='focusableElement' onFocus={this.onFocusHandler} onKeyDown={this.onKeyDown}></a>
                                </foreignObject >
                                : null
                        }
                    </g>
                </g>
            </InteractiveShape>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/Image.js
 **/